export const getImageSrc = (image: any): string => {
  if (!image) return "";

  if (typeof image === "string") {
    return image;
  }

  if (image.desktop?.props?.src) {
    return image.desktop.props.src;
  }

  if (image.props?.src) {
    return image.props.src;
  }

  if (typeof image.src === "string") {
    return image.src;
  }
  
  return "";
};
